import React from 'react'
import { Badge, IconButton, ListItemIcon, ListItemText, MenuItem } from '@material-ui/core'


import { WriteNoteDialog } from './WriteNoteDialog'
import { PinIcon } from 'core/icons'
import { usePostContext } from 'posts/PostContext'
import { OPEN_ADD_NOTE_EVENT, usePostEmitterSubscription } from 'posts/PostEmitter'


const useNotesButton = () => {
    const { notesInfo, post } = usePostContext()
    const [open, setOpen] = React.useState<boolean>(false)

    const handleClose = (open: boolean) => {
        setOpen(!open)
    }

    const postId = post._id

    usePostEmitterSubscription(OPEN_ADD_NOTE_EVENT, ({ postId: requestPostId }) => {
        if (postId != requestPostId) {
            return
        }
        setOpen(true)
    }, [postId])
    return { handleClose, notesInfo, open }
}

export const NotesMenuItem = () => {
    const { handleClose, notesInfo, open } = useNotesButton()

    return (
        <MenuItem
            onClick={(ev: React.MouseEvent) => {
                ev.stopPropagation()
                handleClose(false)
            }}
        >
            <ListItemIcon>
                <IconButton
                    aria-label="show members"
                    color="inherit"
                >
                    <Badge badgeContent={notesInfo?.value || 0} color="secondary">
                        <PinIcon />
                    </Badge>
                </IconButton>
            </ListItemIcon>
            <ListItemText primary={"Open notes..."} />

            {open ? <WriteNoteDialog open={open} handleClose={handleClose} /> : null}
        </MenuItem>
    )
}

export const NotesButton = () => {
    const { handleClose, notesInfo, open } = useNotesButton()

    return (
        <>
            <IconButton
                aria-label="show members" color="inherit"
                onClick={(ev: React.MouseEvent) => {
                    ev.stopPropagation()
                    handleClose(false)
                }}>
                <Badge badgeContent={notesInfo?.value || 0} color="secondary">
                    <PinIcon />
                </Badge>
            </IconButton>
            {open ? <WriteNoteDialog open={open} handleClose={handleClose} /> : null}
        </>
    )
}
